import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
	state: {
		loaded: false,
		general: {},
		assets: {},
		breeds: [],
		info: {},
		mixed_litter: {},
		sounds: {},
		stages: [],
		tutorial: [],
		ui: {},
	},
	actions: {
		loadConfigFromAPI() {
			// TODO: proxy this, but proxying it is slower, so wait until the end
			// once proxies/relative link can act as backup for production
			return Vue.http.get('http://cat-insanity.local/wp-json/dev-api/v1/data/')
				.then(
					response => Promise.resolve(response.body),
					response => Promise.reject(response.body),
				);
		},
		async loadConfig(context) {
			let config = window.DATA;

			if (!config) {
				config = await context.dispatch("loadConfigFromAPI");
			}

			return context.commit("setConfig", config);
		},
		async getGameConfig(context) {
			await context.dispatch("loadConfig");
			context.commit("completeLoad");
		},
	},
	mutations: {
		setConfig(state, payload) {
			// TODO: should be able to replace state with
			// the config object instead of manually adding these
			state.assets = payload.assets;
			state.breeds = payload.cats;
			state.general = payload.config;
			state.info = payload.info;
			state.mixed_litter = payload.mixed_litter;
			state.sounds = payload.sounds;
			state.stages = payload.stages;
			state.tutorial = payload.tutorial;
			state.ui = payload.ui;
		},
		completeLoad(state) {
			state.loaded = true;
		},
	},
	getters: {
		configLoaded(state) {
			return state.loaded;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/config.js